var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "produts" },
    [
      _c("div", { staticClass: "produts-title" }, [_c("custom-breadcrumb")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "produts-top" }, [
        _c("div", { staticClass: "produts-top-tabs" }, [
          _c(
            "div",
            {
              class: { isActive: _vm.tabType == "All" },
              on: {
                click: function($event) {
                  return _vm.tabSwitch("All")
                }
              }
            },
            [_vm._v("All")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { isActive: _vm.tabType == "Active" },
              attrs: { type: "Active" },
              on: {
                click: function($event) {
                  return _vm.tabSwitch("Active")
                }
              }
            },
            [_vm._v("Active")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { isActive: _vm.tabType == "Inactive" },
              on: {
                click: function($event) {
                  return _vm.tabSwitch("Inactive")
                }
              }
            },
            [_vm._v("Inactive")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { isActive: _vm.tabType == "InReview" },
              on: {
                click: function($event) {
                  return _vm.tabSwitch("InReview")
                }
              }
            },
            [_vm._v("In Review")]
          )
        ]),
        _vm._v(" "),
        _vm.brandManagementMode !== 3
          ? _c("div", { staticClass: "btn-product" }, [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.$refs["importPro"].show()
                    }
                  }
                },
                [_vm._v("Import")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "CreateSpu" })
                    }
                  }
                },
                [_vm._v("Add Products")]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "produts-search" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.produtsForm } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Category", clearable: "" },
                      on: {
                        change: function($event) {
                          return _vm.search(false)
                        }
                      },
                      model: {
                        value: _vm.produtsForm.categoryId,
                        callback: function($$v) {
                          _vm.$set(_vm.produtsForm, "categoryId", $$v)
                        },
                        expression: "produtsForm.categoryId"
                      }
                    },
                    _vm._l(_vm.categorysList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.cateName, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("el-date-picker", {
                    attrs: {
                      "value-format": "yyyy-MM-dd",
                      format: "MM.dd.yyyy",
                      type: "date",
                      placeholder: "Last Update"
                    },
                    on: {
                      change: function($event) {
                        return _vm.search(false)
                      }
                    },
                    model: {
                      value: _vm.produtsForm.time,
                      callback: function($$v) {
                        _vm.$set(_vm.produtsForm, "time", $$v)
                      },
                      expression: "produtsForm.time"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input-with-select",
                      staticStyle: { width: "550px" },
                      attrs: {
                        placeholder: "Product name / Brands/Product ID"
                      },
                      model: {
                        value: _vm.produtsForm.keyWords,
                        callback: function($$v) {
                          _vm.$set(_vm.produtsForm, "keyWords", $$v)
                        },
                        expression: "produtsForm.keyWords"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-input__icon el-icon-search",
                        attrs: { slot: "prefix" },
                        slot: "prefix"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "produts-search-button",
                          attrs: { slot: "append" },
                          on: {
                            click: function($event) {
                              return _vm.search(false)
                            }
                          },
                          slot: "append"
                        },
                        [_vm._v("\n            Search\n          ")]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "products-content" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: "calc(100vh - 350px)",
                stripe: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { label: "Name", "min-width": "350" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "table-name" }, [
                          _c("div", { staticClass: "table-img" }, [
                            _c("img", {
                              attrs: { src: scope.row.imgUrl, alt: "" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.title) +
                                "\n              "
                            ),
                            scope.row["reviewStatus"] == 2
                              ? _c("div", { staticClass: "review-mark" }, [
                                  _vm._v("In Review")
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Variations",
                  prop: "variations",
                  "min-width": "100"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "category",
                  "min-width": "100",
                  label: "Category"
                }
              }),
              _vm._v(" "),
              _vm.brandManagementMode == 2 || _vm.brandMode == "4"
                ? [
                    _c("el-table-column", {
                      attrs: { "min-width": "120", label: "Cost Price($)" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v("$ " + _vm._s(scope.row.costRange))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1679380202
                      )
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.brandManagementMode == 1 || _vm.brandMode == "4"
                ? [
                    _c("el-table-column", {
                      attrs: { "min-width": "120", label: "FOB Price($)" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    "  " +
                                      _vm._s(
                                        scope.row.shippingCountry === "China"
                                          ? "$" + scope.row.fobRange
                                          : "——"
                                      )
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1126232046
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        "min-width": "160",
                        label: "Wholesale Price($)"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    "$ " + _vm._s(scope.row.wholesalePrice)
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        520633521
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        "min-width": "180",
                        label: "Suggest Retail Price($)"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(scope.row.suggestRetailPriceRange)
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1549183983
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { "min-width": "160", label: "Procurement Price" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.procurementPriceRange
                                          ? "$" +
                                              scope.row.procurementPriceRange
                                          : "——"
                                      )
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        976974640
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        "min-width": "210",
                        label: "Wholesale Settlement Price"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.kaSettlementPriceRange
                                          ? "$" +
                                              scope.row.kaSettlementPriceRange
                                          : "——"
                                      )
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3314009040
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        "min-width": "180",
                        label: "Shipping from Country"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.shippingCountry
                                        ? scope.row.shippingCountry
                                        : "——"
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1208956788
                      )
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  "min-width": "120",
                  prop: "brandName",
                  label: "Brand Name"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  "min-width": "120",
                  prop: "updateTime",
                  label: "Last Update"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { "min-width": "150", label: "Product Link" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "table-url",
                            on: {
                              click: function($event) {
                                return _vm.openUrl(scope)
                              }
                            }
                          },
                          [_vm._v("View")]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Status", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "cust-active" },
                          [
                            _c(
                              "el-select",
                              {
                                class: { normal: scope.row.goodsStatus == "1" },
                                attrs: { placeholder: "Please Select" },
                                on: {
                                  change: function(v) {
                                    return _vm.changeGoodsStatus(v, scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.goodsStatus,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "goodsStatus", $$v)
                                  },
                                  expression: "scope.row.goodsStatus"
                                }
                              },
                              _vm._l(_vm.goodsStatusOptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Action" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("i", {
                          staticClass: "el-icon-edit-outline",
                          on: {
                            click: function($event) {
                              return _vm.edit(scope.row)
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.brandMode == "4"
                ? [
                    _c("el-table-column", {
                      attrs: { width: "190", label: "Review" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row["reviewStatus"] == 2
                                  ? _c("div", { staticClass: "review" }, [
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.review(
                                                "p",
                                                scope.row["id"]
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Pass")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.review(
                                                "r",
                                                scope.row["id"]
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Reject")]
                                      )
                                    ])
                                  : scope.row["reviewStatus"] == 1
                                  ? _c("span", [_vm._v("Pass")])
                                  : scope.row["reviewStatus"] == 0
                                  ? _c("span", [_vm._v("Reject")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1842078120
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Reviewer" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row["approvedBy"]) +
                                    "\n          "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3449985893
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { width: "190", label: "Last Modified By" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row["lastModifyBy"]) +
                                    "\n          "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1701643924
                      )
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: {
          currentPage: _vm.paging.current,
          total: _vm.paging.total,
          pageSize: _vm.paging.size
        },
        on: {
          handleSizeChange: _vm.handleSizeChange,
          handleCurrentChange: _vm.handleCurrentChange
        }
      }),
      _vm._v(" "),
      _c("import-products", { ref: "importPro" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f279f6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f279f6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/produts/index.vue
// module id = U4r5
// module chunks = 2